var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.279975 13.3294C0.368157 13.4138 0.472913 13.4807 0.588244 13.5263C0.703575 13.572 0.827215 13.5955 0.95208 13.5955C1.07695 13.5955 1.20059 13.572 1.31592 13.5263C1.43125 13.4807 1.536 13.4138 1.62418 13.3294L7.93513 7.30864C8.00553 7.24161 8.06139 7.16199 8.0995 7.07434C8.13761 6.9867 8.15723 6.89274 8.15723 6.79785C8.15723 6.70296 8.13761 6.609 8.0995 6.52135C8.06139 6.4337 8.00553 6.35409 7.93513 6.28706L1.62418 0.266261C1.25206 -0.088756 0.652099 -0.0887559 0.279974 0.266261C-0.0921518 0.621278 -0.0921518 1.19365 0.279974 1.54867L5.77832 6.80147L0.272382 12.0543C-0.0921498 12.402 -0.0921507 12.9817 0.279975 13.3294Z",
    fill: "#1E232C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrowRightBlack.9e1e90c6c1ae8f5f9371d85c303d7f24.svg";
export { ForwardRef as ReactComponent };